{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Cancelar",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integraciones",
    "DESCRIPTION": "Chatwoot se integra con múltiples herramientas y servicios para mejorar la eficiencia de tu equipo. Explora la lista de abajo para configurar tus aplicaciones favoritas.",
    "LEARN_MORE": "Más información acerca de integraciones",
    "LOADING": "Obteniendo integraciones",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "El capitán no está habilitado en tu cuenta.",
      "CLICK_HERE_TO_CONFIGURE": "Haz clic aquí para configurar",
      "LOADING_CONSOLE": "Cargando consola del capitán...",
      "FAILED_TO_LOAD_CONSOLE": "No se pudo cargar la consola del capitán. Por favor, actualiza e inténtalo de nuevo."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Eventos suscritos",
      "LEARN_MORE": "Aprenda más sobre webhooks",
      "PAYWALL": {
        "TITLE": "Los webhooks están disponibles en planes de pago",
        "AVAILABLE_ON": "Usa webhooks para recibir eventos en tiempo real de tu cuenta de Chatwoot.",
        "UPGRADE_PROMPT": "Actualice a Startups, Business, o Enterprise planea usar webhooks.",
        "UPGRADE_NOW": "Actualizar ahora",
        "CANCEL_ANYTIME": "Cambie o cancele su plan en cualquier momento."
      },
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Cancelar",
        "DESC": "Los eventos Webhook te proporcionan la información en tiempo real sobre lo que está sucediendo en tu cuenta de Chatwoot. Por favor, introduce una URL válida para configurar un callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Eventos",
          "EVENTS": {
            "CONVERSATION_CREATED": "Conversación creada",
            "CONVERSATION_STATUS_CHANGED": "Estado de la conversación cambiado",
            "CONVERSATION_UPDATED": "Conversación actualizada",
            "MESSAGE_CREATED": "Mensaje creado",
            "MESSAGE_UPDATED": "Mensaje actualizado",
            "WEBWIDGET_TRIGGERED": "Widget de Live Chat abierto por el usuario",
            "CONTACT_CREATED": "Contacto creado",
            "CONTACT_UPDATED": "Contacto actualizado",
            "CONVERSATION_TYPING_ON": "Conversation Typing On",
            "CONVERSATION_TYPING_OFF": "Conversation Typing Off",
            "INBOX_UPDATED": "Bandeja de entrada actualizada"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "URL de Webhook",
          "PLACEHOLDER": "Ejemplo: {webhookExampleURL}",
          "ERROR": "Por favor, introduzca una URL válida"
        },
        "EDIT_SUBMIT": "Actualizar webhook",
        "ADD_SUBMIT": "Crear webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configurar",
      "HEADER": "Configuración de Webhook",
      "HEADER_BTN_TXT": "Añadir nuevo webhook",
      "LOADING": "Obteniendo webhooks adjuntos",
      "SEARCH_404": "No hay elementos que coincidan con esta consulta",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks son callbacks HTTP que se pueden definir para cada cuenta. Son activados por eventos como la creación de mensajes en Chatwoot. Puede crear más de un webhook para esta cuenta. <br /><br /> Para crear un webhook <b></b>, haga clic en el <b>Añadir un nuevo webhook</b> botón. También puede eliminar cualquier webhook existente haciendo clic en el botón Borrar.</p>",
      "LIST": {
        "404": "No hay webhooks configurados para esta cuenta.",
        "TITLE": "Administrar webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Final de Webhook",
          "ACTIONS": "Acciones"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Editar",
        "TITLE": "Editar Webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuración de webhook actualizada correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        }
      },
      "ADD": {
        "CANCEL": "Cancelar",
        "TITLE": "Añadir nuevo webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuración de webhook añadida correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Eliminar",
        "API": {
          "SUCCESS_MESSAGE": "Webhook eliminado correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        },
        "CONFIRM": {
          "TITLE": "Confirmar eliminación",
          "MESSAGE": "¿Está seguro de eliminar el webhook? ({webhookURL})",
          "YES": "Sí, eliminar ",
          "NO": "No, mantenerlo"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Eliminar",
      "DELETE_CONFIRMATION": {
        "TITLE": "Eliminar la integración",
        "MESSAGE": "¿Está seguro que desea eliminar la integración? Si lo hace, perderá el acceso a las conversaciones en su espacio de trabajo Slack."
      },
      "HELP_TEXT": {
        "TITLE": "¿Cómo utilizar la Integración Slack?",
        "BODY": "Con esta integración, todas tus conversaciones entrantes serán sincronizadas con el canal ***{selectedChannelName}*** en tu espacio de trabajo en Slack. Puedes administrar todas tus conversaciones con los clientes directamente en tu canal y nunca perder un mensaje.\n\nEstas son las principales características de la integración:\n\n**Responda a conversaciones desde Slack:** Para responder a una conversación en el canal Slack ***{selectedChannelName}***, simplemente escriba el mensaje y envíalo como un hilo. Esto creará una respuesta que se enviará al cliente mediante Chatwoot. ¡Es así de simple!\n\n**Crea notas privadas:** Si quieres crear una nota privada en lugar de una respuesta, comience su mensaje con ***`note:`***. Esto asegurará que tu mensaje se mantenga privado y no será visible al cliente.\n\n**Asociar un perfil de agente:** Si la persona que responde en Slack tiene un agente de perfil en Chatwoot bajo el mismo correo electrónico, las respuestas serán asociadas con ese perfil de agente automáticamente. Esto quiere decir que puedes fácilmente estar al tanto de quién dijo qué y cuándo. Por el otro lado, cuando la persona que responde no tiene un perfil de agente, las respuestas aparecerán desde el perfil de bot al cliente.",
        "SELECTED": "seleccionado"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Seleccione un canal",
        "UPDATE": "Actualizar",
        "BUTTON_TEXT": "Conectar canal",
        "DESCRIPTION": "Su espacio de trabajo de Slack ahora esta enlazado con Chatwoot. Sin embarbo, la integración esta actualmente inactiva. Para activar la integración y conectar un canal a Chatwoot, por favor haga clic en el siguiente boton.\n\n**Nota.** Si esta intentando conectar un canal privado, agregue la aplicación Chatwoot al canal de Slack antes de proceder con este paso.",
        "ATTENTION_REQUIRED": "Atención requerida",
        "EXPIRED": "Su integración de Slack ha caducado. Para continuar recibiendo mensajes en Slack, por favor elimine la integración y vuelva a conectar su área de trabajo."
      },
      "UPDATE_ERROR": "Se presento un error actualizando la integración, por favor inténtelo nuevamente",
      "UPDATE_SUCCESS": "El canal está conectado correctamente",
      "FAILED_TO_FETCH_CHANNELS": "Hubo un error obteniendo los canales de Slack, por favor inténtalo de nuevo"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Haga clic aquí para unirse",
      "LEAVE_THE_ROOM": "Abandonar la sala",
      "START_VIDEO_CALL_HELP_TEXT": "Iniciar una nueva videollamada con el cliente",
      "JOIN_ERROR": "Hubo un error al unirse a la llamada, por favor intente de nuevo",
      "CREATE_ERROR": "Hubo un error al crear un enlace de reunión, por favor inténtelo de nuevo"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Asistencia AI",
      "WITH_AI": " {option} con IA ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Responder sugerencia",
        "SUMMARIZE": "Resumir",
        "REPHRASE": "Mejorar escritura",
        "FIX_SPELLING_GRAMMAR": "Corregir ortografía y gramática",
        "SHORTEN": "Acortar",
        "EXPAND": "Expandir",
        "MAKE_FRIENDLY": "Cambiar tono de mensaje a amigable",
        "MAKE_FORMAL": "Usar tono formal",
        "SIMPLIFY": "Simplificar",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Profesional",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Amigable"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Contenido de borrador",
        "GENERATED_TITLE": "Contenido generado",
        "AI_WRITING": "AI está escribiendo",
        "BUTTONS": {
          "APPLY": "Usar esta sugerencia",
          "CANCEL": "Cancelar"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrar con OpenAI",
        "DESC": "Trae las características avanzadas de IA a tu panel de control con los modelos GPT de OpenAI. Para empezar, introduce la clave API desde tu cuenta OpenAI.",
        "KEY_PLACEHOLDER": "Introduzca su clave API OpenAI",
        "BUTTONS": {
          "NEED_HELP": "¿Necesitas ayuda?",
          "DISMISS": "Descartar",
          "FINISH": "Finalizar configuración"
        },
        "DISMISS_MESSAGE": "Puedes configurar la integración OpenAI más tarde cuando quieras.",
        "SUCCESS_MESSAGE": "Configuración de integración OpenAI exitosa"
      },
      "TITLE": "Mejorar con IA",
      "SUMMARY_TITLE": "Resumen con IA",
      "REPLY_TITLE": "Responder sugerencia con IA",
      "SUBTITLE": "Se generará una respuesta mejorada usando IA basada en tu borrador actual.",
      "TONE": {
        "TITLE": "Tono",
        "OPTIONS": {
          "PROFESSIONAL": "Profesional",
          "FRIENDLY": "Amigable"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generar",
        "GENERATING": "Generando...",
        "CANCEL": "Cancelar"
      },
      "GENERATE_ERROR": "Hubo un error al procesar el contenido, por favor verifique su clave API OpenAI e inténtelo de nuevo"
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "API": {
        "SUCCESS_MESSAGE": "Integración eliminada correctamente"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectar"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Panel de aplicaciones",
      "HEADER_BTN_TXT": "Añadir una nueva aplicación",
      "SIDEBAR_TXT": "<p><b>Aplicaciones de panel</b></p><p>Aplicaciones de panel de control permiten a las organizaciones incrustar una aplicación dentro del panel de control de Chatwoot para proporcionar el contexto para los agentes de atención al cliente. Esta característica le permite crear una aplicación de forma independiente e incrustarla dentro del panel de control para proporcionar información de usuario, sus pedidos, o su historial de pagos anterior.</p><p>Cuando incrustas tu aplicación usando el panel de control en Chatwoot, tu aplicación obtendrá el contexto de la conversación y el contacto como un evento de ventana. Implementa un oyente para el evento del mensaje en tu página para recibir el contexto.</p><p>Para añadir una nueva aplicación de panel, haga clic en el botón 'Añadir una nueva aplicación de panel'.</p>",
      "DESCRIPTION": "Las aplicaciones de panel permiten a las organizaciones incrustar una aplicación dentro del panel de control para proporcionar el contexto para los agentes de soporte al cliente. Esta función le permite crear una aplicación de forma independiente e incrustada para proporcionar información de usuario, sus pedidos o su historial de pagos anterior.",
      "LEARN_MORE": "Aprende más sobre el panel de aplicaciones",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "Todavía no hay aplicaciones configuradas en esta cuenta",
        "LOADING": "Obteniendo aplicaciones del tablero...",
        "TABLE_HEADER": {
          "NAME": "Nombre",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Acciones"
        },
        "EDIT_TOOLTIP": "Editar aplicación",
        "DELETE_TOOLTIP": "Eliminar aplicación"
      },
      "FORM": {
        "TITLE_LABEL": "Nombre",
        "TITLE_PLACEHOLDER": "Ingrese un nombre para su aplicación de tablero",
        "TITLE_ERROR": "Se requiere un nombre para el panel de control",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Introduzca la URL del endpoint donde se aloja su aplicación",
        "URL_ERROR": "Se requiere una URL válida"
      },
      "CREATE": {
        "HEADER": "Añadir una nueva aplicación",
        "FORM_SUBMIT": "Enviar",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "Panel de control configurado correctamente",
        "API_ERROR": "No pudimos crear una aplicación. Por favor, inténtalo de nuevo más tarde"
      },
      "UPDATE": {
        "HEADER": "Editar panel de aplicación",
        "FORM_SUBMIT": "Actualizar",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "Panel de control actualizado correctamente",
        "API_ERROR": "No pudimos actualizar la aplicación. Por favor, inténtalo de nuevo más tarde"
      },
      "DELETE": {
        "CONFIRM_YES": "Sí, eliminarlo",
        "CONFIRM_NO": "No, mantenerlo",
        "TITLE": "Confirme eliminación",
        "MESSAGE": "¿Está seguro que desea eliminar la aplicación - {appName}?",
        "API_SUCCESS": "Panel de control eliminado con éxito",
        "API_ERROR": "No pudimos eliminar la aplicación. Por favor, inténtalo de nuevo más tarde"
      }
    },
    "LINEAR": {
      "HEADER": "Lineal",
      "ADD_OR_LINK_BUTTON": "Crear/Enlazar Problema Linear",
      "LOADING": "Cargando problemas lineales...",
      "LOADING_ERROR": "Hubo un error al recuperar los problemas lineales, por favor inténtalo de nuevo",
      "CREATE": "Crear",
      "LINK": {
        "SEARCH": "Buscar problemas",
        "SELECT": "Seleccionar problema",
        "TITLE": "Enlace",
        "EMPTY_LIST": "No se encontraron problemas lineales",
        "LOADING": "Cargando",
        "ERROR": "Hubo un error al recuperar los problemas lineales, por favor inténtalo de nuevo",
        "LINK_SUCCESS": "Incidencia enlazada correctamente",
        "LINK_ERROR": "Ocurrió un error al enlazar la incidencia. Inténtelo de nuevo",
        "LINK_TITLE": "Conversación (#{conversationId}) con {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Crear/enlazar incidencia con Linear",
        "DESCRIPTION": "Crear incidencias en Linear desde conversaciones, o enlazar existentes para un seguimiento fluido.",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Introducir título",
            "REQUIRED_ERROR": "El título es obligatorio"
          },
          "DESCRIPTION": {
            "LABEL": "Descripción",
            "PLACEHOLDER": "Introducir descripción"
          },
          "TEAM": {
            "LABEL": "Equipo",
            "PLACEHOLDER": "Seleccionar equipo",
            "SEARCH": "Buscar equipos",
            "REQUIRED_ERROR": "El equipo es requerido"
          },
          "ASSIGNEE": {
            "LABEL": "Cesionario",
            "PLACEHOLDER": "Seleccionar asignado",
            "SEARCH": "Buscar asignado"
          },
          "PRIORITY": {
            "LABEL": "Prioridad",
            "PLACEHOLDER": "Seleccionar prioridad",
            "SEARCH": "Buscar prioridad"
          },
          "LABEL": {
            "LABEL": "Etiqueta",
            "PLACEHOLDER": "Seleecionar etiqueta",
            "SEARCH": "Buscar etiqueta"
          },
          "STATUS": {
            "LABEL": "Estado",
            "PLACEHOLDER": "Seleccionar estado",
            "SEARCH": "Buscar estado"
          },
          "PROJECT": {
            "LABEL": "Proyecto",
            "PLACEHOLDER": "Seleccionar proyecto",
            "SEARCH": "Buscar proyecto"
          }
        },
        "CREATE": "Crear",
        "CANCEL": "Cancelar",
        "CREATE_SUCCESS": "Incidencia creada correctamente",
        "CREATE_ERROR": "Hubo un error creando la incidencia. Inténtalo de nuevo",
        "LOADING_TEAM_ERROR": "Hubo un error al coger los equipos. Inténtalo de nuevo",
        "LOADING_TEAM_ENTITIES_ERROR": "Hubo un error al coger las entidades del equipo. Inténtalo de nuevo"
      },
      "ISSUE": {
        "STATUS": "Estado",
        "PRIORITY": "Prioridad",
        "ASSIGNEE": "Cesionario",
        "LABELS": "Etiquetas",
        "CREATED_AT": "Creado en {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Desenlazar",
        "SUCCESS": "Problema desvinculado con éxito",
        "ERROR": "Se ha producido un error al desvincular el problema, inténtelo de nuevo"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Sí, eliminar",
        "CANCEL": "Cancelar"
      },
      "CTA": {
        "TITLE": "Connect to Linear",
        "AGENT_DESCRIPTION": "Linear workspace is not connected. Request your administrator to connect a workspace to use this integration.",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "Connect Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "Sí, eliminar",
        "CANCEL": "Cancelar"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Capitán",
    "HEADER_KNOW_MORE": "Más información",
    "OVERVIEW": {
      "HEADER": "Resumen",
      "WELCOME": {
        "LABEL": "Resumen del capitán",
        "LOADING": "Generando resumen…"
      },
      "INBOX_BANNER": {
        "TEXT": "Este asistente aún no está conectado a ninguna bandeja de entrada, por lo que no responderá a las conversaciones.",
        "ACTION": "Conectar bandeja de entrada",
        "DISMISS": "Descartar"
      },
      "COVERAGE_BANNER": {
        "TEXT": "Las Preguntas Frecuentes {count} están pendientes de revisión, manteniendo la cobertura en {coverage}%. Aprovéchalas para que tu asistente pueda resolver más por sí solo.",
        "ACTION": "Revisar FAQs",
        "DISMISS": "Descartar"
      },
      "RANGES": {
        "LAST_DAYS": "Últimos {count} días",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month"
      },
      "METRICS": {
        "HANDLED": {
          "LABEL": "Conversaciones manejadas",
          "HINT": "Distintas conversaciones en las que respondió este asistente."
        },
        "AUTO_RESOLUTION": {
          "LABEL": "Tasa de resolución automática",
          "HINT": "Compartido de conversaciones manejadas cerradas sin una respuesta humana."
        },
        "HANDOFF": {
          "LABEL": "Tasa de desconexión",
          "HINT": "Comparte las conversaciones manipuladas escaladas a un agente humano."
        },
        "HOURS_SAVED": {
          "LABEL": "Tiempo ahorrado",
          "HINT": "Estimado: El Capitán responde veces ~2 minutos de esfuerzo de agente asumido por respuesta. Trabajo direccional, no medido."
        },
        "REOPEN": {
          "LABEL": "Reabrir tasa",
          "HINT": "Conversaciones resueltas automáticamente que se reabrieron después."
        },
        "DEPTH": {
          "LABEL": "Mensajes / conversación",
          "HINT": "Promedio de respuestas que el asistente envía por conversación."
        }
      },
      "DRILLDOWN": {
        "CLOSE": "Detalles de cierre",
        "EMPTY": "No se encontraron registros para esta métrica.",
        "ERROR": "No se pudo cargar los registros. Por favor, inténtelo de nuevo.",
        "LOAD_MORE": "Cargar más",
        "RESULT_COUNT_CONVERSATION": "Conversación {count} | Conversaciones {count}"
      },
      "KNOWLEDGE": {
        "TITLE": "Cobertura del conocimiento",
        "COVERAGE": "{pct}% aprobado",
        "APPROVED": "FAQs Aprobadas",
        "PENDING": "Pending FAQs",
        "DOCUMENTS": "Documents"
      },
      "LINKS": {
        "DOCS": {
          "TITLE": "Capitán documentos",
          "DESCRIPTION": "Guías y cómo para el Capitán"
        },
        "PLAYGROUND": {
          "TITLE": "Zona de pruebas",
          "DESCRIPTION": "Probar las respuestas de este asistente"
        },
        "BILLING": {
          "TITLE": "Facturación",
          "DESCRIPTION": "Gestionar créditos y plan"
        }
      }
    },
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Asistentes",
      "SWITCH_ASSISTANT": "Cambiar entre asistentes",
      "NEW_ASSISTANT": "Crear asistente",
      "EMPTY_LIST": "No se encontraron asistentes. Crea uno para comenzar"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Prueba estas sugerencias",
      "PANEL_TITLE": "Comienza con Copilot",
      "KICK_OFF_MESSAGE": "¿Necesitas un resumen rápido, revisar conversaciones anteriores o redactar una mejor respuesta? Copilot está aquí para agilizarlo.",
      "SEND_MESSAGE": "Enviar mensaje...",
      "EMPTY_MESSAGE": "Se produjo un error al generar la respuesta. Inténtalo de nuevo.",
      "LOADER": "Captain está pensando",
      "YOU": "Tú",
      "USE": "Usar esto",
      "RESET": "Restablecer",
      "SHOW_STEPS": "Mostrar pasos",
      "SELECT_ASSISTANT": "Seleccionar asistente",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Resume esta conversación",
          "CONTENT": "Resume los puntos clave tratados entre el cliente y el agente de soporte, incluidas las inquietudes y preguntas del cliente, así como las soluciones o respuestas proporcionadas por el agente de soporte."
        },
        "SUGGEST": {
          "LABEL": "Sugerir una respuesta",
          "CONTENT": "Analiza la consulta del cliente y redacta una respuesta que aborde eficazmente sus dudas o preguntas. Asegúrate de que la respuesta sea clara, concisa y útil."
        },
        "RATE": {
          "LABEL": "Califica esta conversación",
          "CONTENT": "Revisa la conversación para evaluar qué tan bien satisface las necesidades del cliente. Comparte una calificación sobre 5 basada en el tono, la claridad y la eficacia."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Conversaciones de alta prioridad",
          "CONTENT": "Dame un resumen de todas las conversaciones abiertas de alta prioridad. Incluye el ID de la conversación, el nombre del cliente (si está disponible), el contenido del último mensaje y el agente asignado. Agrupa por estado si es relevante."
        },
        "LIST_CONTACTS": {
          "LABEL": "Listar contactos",
          "CONTENT": "Muéstrame la lista de los 10 contactos principales. Incluye el nombre, el correo electrónico o número de teléfono (si está disponible), la hora de la última actividad y las etiquetas (si las hay)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Tú",
      "ASSISTANT": "Asistente",
      "MESSAGE_PLACEHOLDER": "Escribe tu mensaje...",
      "HEADER": "Zona de pruebas",
      "DESCRIPTION": "Usa esta zona de pruebas para enviar mensajes a tu asistente y comprobar si responde con precisión, rapidez y con el tono que esperas.",
      "CREDIT_NOTE": "Los mensajes enviados aquí contarán para tus créditos de Captain."
    },
    "PAYWALL": {
      "TITLE": "Actualiza para usar Captain AI",
      "AVAILABLE_ON": "Captain no está disponible en el plan gratuito.",
      "UPGRADE_PROMPT": "Actualiza tu plan para obtener acceso a nuestros asistentes, Copilot y más.",
      "UPGRADE_NOW": "Actualizar ahora",
      "CANCEL_ANYTIME": "Puede cambiar o cancelar su plan en cualquier momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI solo está disponible en los planes Enterprise.",
      "UPGRADE_PROMPT": "Actualiza tu plan para obtener acceso a nuestros asistentes, Copilot y más.",
      "ASK_ADMIN": "Por favor, comuníquese con su administrador para la actualización."
    },
    "BANNER": {
      "RESPONSES": "Has usado más del 80 % de tu límite de respuestas. Para seguir usando Captain AI, actualiza tu plan.",
      "DOCUMENTS": "Se alcanzó el límite de documentos. Actualiza para seguir usando Captain AI."
    },
    "FORM": {
      "CANCEL": "Cancelar",
      "CREATE": "Crear",
      "EDIT": "Actualizar"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "NO_ASSISTANTS_AVAILABLE": "There are no assistants available in your account.",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "UPDATE": "Actualizar",
        "SECTIONS": {
          "BASIC_INFO": "Basic Information",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Instructions",
          "FEATURES": "Características",
          "TOOLS": "Tools "
        },
        "NAME": {
          "LABEL": "Nombre",
          "PLACEHOLDER": "Enter assistant name",
          "ERROR": "The name is required"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Enter assistant description",
          "ERROR": "The description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter product name",
          "ERROR": "The product name is required"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Welcome Message",
          "PLACEHOLDER": "Enter welcome message"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Handoff Message",
          "PLACEHOLDER": "Enter handoff message"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Resolution Message",
          "PLACEHOLDER": "Enter resolution message"
        },
        "INSTRUCTIONS": {
          "LABEL": "Instructions",
          "PLACEHOLDER": "Enter instructions for the assistant"
        },
        "FEATURES": {
          "TITLE": "Características",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions.",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again.",
        "NOT_FOUND": "Could not find the assistant. Please try again."
      },
      "SETTINGS": {
        "HEADER": "Ajustes",
        "BASIC_SETTINGS": {
          "TITLE": "Configuraciones básicas",
          "DESCRIPTION": "Personaliza lo que dice el asistente al finalizar una conversación o al transferirla a una persona."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "System settings",
          "DESCRIPTION": "Personaliza lo que dice el asistente al finalizar una conversación o al transferirla a una persona."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Delete Assistant",
          "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
          "BUTTON_TEXT": "Delete {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Eliminar"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "Crear",
            "CANCEL": "Cancelar",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Buscar..."
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Eliminar"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "Crear",
            "CANCEL": "Cancelar",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Buscar..."
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Eliminar"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Título",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "Descripción",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "Crear",
              "CANCEL": "Cancelar"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Cancelar",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Buscar..."
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "FAQ_COUNT": "Preguntas frecuentes {n} | Preguntas frecuentes {n}",
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "BULK_DELETE_BUTTON": "Eliminar",
      "BULK_SYNC_BUTTON": "Actualizar",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Actualizar en cola para 1 documento",
        "SUCCESS_MESSAGE": "Actualizar en cola para {count} documentos",
        "ZERO_MESSAGE": "No hay documentos marcados para refrescar.",
        "ERROR_MESSAGE": "Hubo un error al poner en cola la actualización, por favor inténtalo de nuevo."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Actualización en cola. Actualizaremos el documento en breve.",
        "ERROR_MESSAGE": "No se pudo actualizar la cola, por favor inténtalo de nuevo."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "Todas las fuentes",
          "WEB": "Páginas web",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Cualquier estado",
          "UPDATED": "Actualizado",
          "NEEDS_UPDATE": "Necesita actualización",
          "UPDATING": "Actualizando",
          "FAILED": "Failed"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Actualizado recientemente",
          "RECENTLY_CREATED": "Creado recientemente"
        },
        "SEARCH_PLACEHOLDER": "Buscar..."
      },
      "SYNC_STATUS": {
        "SYNCED": "última actualización {time}",
        "SYNCING": "actualizando...",
        "STALE_SYNC": "actualización bloqueada",
        "FAILED": "Fallo al sincronizar",
        "NEVER_SYNCED": "no actualizado aún"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Página no encontrada",
        "ACCESS_DENIED": "Acceso denegado",
        "TIMEOUT": "La página tardó demasiado en responder",
        "CONTENT_EMPTY": "La página devolvió contenido vacío",
        "FETCH_FAILED": "No se pudo obtener la página",
        "SYNC_ERROR": "Error inesperado",
        "DEFAULT": "Error de sincronización"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "EMPTY": "Aún no se han generado FAQs de este documento."
      },
      "DETAILS": {
        "DESCRIPTION": "Revise el contenido acumulado y las preguntas frecuentes generadas a partir de esta fuente.",
        "SOURCE": "Fuente",
        "GENERATED_FAQS": "FAQs generadas",
        "LAST_UPDATED": "Última actualización",
        "NOT_AVAILABLE": "No disponible",
        "CONTENT_TAB": "Contenido arrastrado",
        "PDF_TAB": "Detalles PDF",
        "CONTENT_TITLE": "Contenido arrastrado",
        "PDF_TITLE": "Archivo PDF",
        "PDF_DESCRIPTION": "Revise la fuente PDF original.",
        "CHARACTER_COUNT": "{count} caracteres extraídos",
        "COPY_CONTENT": "Copiar",
        "COPY_SUCCESS": "Contenido arrastrado copiado al portapapeles",
        "COPY_ERROR": "No se pudo copiar el contenido",
        "VIEW_RAW": "Ver crudo",
        "VIEW_PREVIEW": "Ver vista previa",
        "UNREADABLE_CONTENT": "El contenido legible no se pudo extraer de este documento. Puede ver el contenido extraído en bruto.",
        "EMPTY_CONTENT": "Aún no hay contenido grabado disponible para este documento."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "URL",
          "PDF": "PDF File"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "PDF_FILE": {
          "LABEL": "PDF File",
          "CHOOSE_FILE": "Choose PDF file",
          "ERROR": "Please select a PDF file",
          "HELP_TEXT": "Maximum file size: 10MB",
          "INVALID_TYPE": "Please select a valid PDF file",
          "TOO_LARGE": "File size exceeds 10MB limit"
        },
        "NAME": {
          "LABEL": "Document Name (Optional)",
          "PLACEHOLDER": "Enter a name for the document"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_DETAILS": "Ver detalles",
        "SYNC_NOW": "Refrescar ahora",
        "RETRY_SYNC": "Reintentar refresco",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FILTERED_TITLE": "No hay documentos coincidentes",
        "FILTERED_SUBTITLE": "Intenta cambiar la fuente, el estado o el término de búsqueda.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Tools",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Abrir facturación",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Por favor, comuníquese con su administrador para la actualización."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "Ninguna",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "Clave de API"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "Contraseña",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Tipo"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "Número",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Requerido"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Preguntas frecuentes",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "SEARCH_PLACEHOLDER": "Search FAQs...",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Eliminar",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Todos"
      },
      "STATUS": {
        "TITLE": "Estado",
        "PENDING": "Pendientes",
        "APPROVED": "Approved",
        "ALL": "Todos"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Approve",
        "EDIT_RESPONSE": "Editar",
        "DELETE_RESPONSE": "Eliminar"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Desconectar"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Bandeja de entrada",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
